import { CommonDataOptions, useCommonDataProvider } from 'app/dataProviders/useCommonDataProvider'
import { RecurrentBankCard, RecurrentBankCardParams } from 'app/dataTypes/acquiring/recurrent/cards'

import {
  GET_ACQUIRING_SAVED_BANK_CARDS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/payments/acquiring2/saved_bank_cards/get'

const defaultState: Array<RecurrentBankCard> = []

type Options = CommonDataOptions<Array<RecurrentBankCard>, RecurrentBankCardParams>

/**
 * Hook для получения списка сохраненных карт.
 *
 * @returns - Результат, возвращаемый запросом {@link GET_ACQUIRING_SAVED_BANK_CARDS}
 *
 * @example
 * const { data, loading, error } = useRecurringSavedBankCards()
 */
export function useRecurrentSavedBankCards(options: Options = {} as Options) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_ACQUIRING_SAVED_BANK_CARDS,
    error: 'Не удалось получить данные сохраненных карт',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
